/** Бриф героини: свободный текст, сохраняется сам при уходе из поля (только если изменился). */
import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";

import { ErrorLine, Hint, Panel } from "@/components/project/ui";
import { saveBrief } from "@/lib/persona";
import { errorText } from "@/lib/project";

export function BriefPanel({ pid, brief, onSaved }: { pid: number; brief: string | null; onSaved: () => void }) {
  const saved = brief ?? "";
  const [text, setText] = useState(saved);
  const [flash, setFlash] = useState(false);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);

  const save = useMutation({
    mutationFn: (value: string) => saveBrief(pid, value),
    onSuccess: () => {
      setFlash(true);
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setFlash(false), 1500);
      onSaved();
    },
  });

  return (
    <Panel title="Бриф" aside={flash ? "сохранено" : save.isPending ? "сохраняю…" : undefined} annot="бриф героини">
      <textarea
        value={text}
        rows={6}
        onChange={(e) => setText(e.target.value)}
        onBlur={() => {
          if (text !== saved && !save.isPending) save.mutate(text);
        }}
        placeholder="Кто она: возраст, внешность, характер, стиль — по-русски, как рассказали бы художнику."
        className="w-full resize-y rounded-[var(--radius-ui)] border border-border bg-bg px-2.5 py-2 text-[12.5px] text-fg outline-none placeholder:text-fg-faint focus:border-accent"
      />
      <Hint className="mt-1">Сохраняется, когда вы выходите из поля.</Hint>
      {save.isError ? <ErrorLine text={errorText(save.error)} className="mt-2" /> : null}
    </Panel>
  );
}
